<!-- eslint-disable -->
<template lang="pug">
    .find-opponent
        .find-opponent__loader
            img(src="../../../assets/images/battles/loader.png")
        .find-opponent__title {{ titleText }}
        button.button.find-opponent__cancel-button(v-if='!isTraining' @click="cancelInvite") {{ $i18n.t('trainer.trainer_generator_cancel') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    export default {
        props: {
            status: {
                type: String,
                default: "searching_for_opponent",
            },
            isTraining: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            cancelInvite () {
                if (this.status !== "no_opponents") {
                    this.$emit('cancelInvite', false);
                } else {
                    this.$router.push({name: this.prevRoute.name, params: this.prevRoute.params});
                }
            }
        },
        computed: {
            ...mapState({
                prevRoute: state => state.router.previousRoute,
            }),
            titleText () {
                if (this.isTraining) {
                    return this.$i18n.t(`battle.battle_sending_invitation`);
                } else {
                    return this.$i18n.t(`battle.battle_${this.status}`);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .find-opponent {
        box-sizing: border-box;
        width: 100%;
        max-height: 300px;
        max-width: 600px;
        margin: 0 auto;
        padding: 20px;
        background: #F7F7FF;
        border-radius: 20px;

        font-family: Rubik;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
        text-align: center;
    }
    .find-opponent__loader {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        animation: spin 2s linear infinite;
    }
    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }
    .find-opponent__title {
        margin: 20px 0;
    }
    .button {
        height: auto;
        border-radius: 40px;
        padding: 15px 30px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        border: 0;
    }
    .find-opponent__cancel-button {
        background: #FF7245;
        color: #FFFFFF;
        &:hover {
            cursor: pointer;
            background: #F55A29;
        }
    }
</style>
